import { UntypedFormControl, ValidationErrors } from "@angular/forms";
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';

export function AlphaNumericValidator(control: UntypedFormControl): ValidationErrors {
  return !control.value || /^[a-zA-Z0-9]+$/.test(control.value) ? null : { 'alphaNumeric': true };
}

export function NumericValidator(control: UntypedFormControl, field?: FormlyFieldConfig ): ValidationErrors {
  const isNumericValidatorEnabled = field?.templateOptions?.numericValidatorEnabled ?? true;
  if (!isNumericValidatorEnabled) {
    return null;
  }
  return !control.value || /(^[0-9]\d*$)/.test(control.value) ? null : { 'numeric': true };
}

export function EmailValidator(control: UntypedFormControl): ValidationErrors {
  return !control.value || /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(control.value) ? null : { 'email': true };
}

export function currencyValidator(control: UntypedFormControl): ValidationErrors {
  return !control.value || /^[0-9.,]*$/.test(control.value) ? null : { 'numeric': true };
}

export function dateFutureValidator(control: UntypedFormControl, field: FormlyFieldConfig, options = {}): ValidationErrors {
  if (new Date(control.value) >= new Date()) {
    return { 'date-future': { message: 'Date cannot be in the future' } };
  }
}

export function AlphaNumericAndSpecialCharsValidator(control: UntypedFormControl): ValidationErrors {
  return !control.value || /^[a-zA-Z0-9\u2013\u002d().,'+\n\r\s]+$/.test(control.value) ? null : { 'alphanumericandspecialchars': true };
}


export function signedCurrencyValidator(control: UntypedFormControl): ValidationErrors {
  return !control.value || /^-?[0-9.,]*$/.test(control.value) ? null : { 'numeric': true };
}

export function integerValidator(control: UntypedFormControl): ValidationErrors {
  return !control.value || /^[0-9]+$/.test(control.value) ? null : { 'integer': true };
}

export function showError(field: FieldType) {
  return field.formControl && field.formControl.invalid && (field.formControl.touched || field.formControl.dirty || (field.options.parentForm && field.options.parentForm.submitted) || (field.field.validation && field.field.validation.show));
}

